import { Component, OnInit, ViewChild } from "@angular/core";

import { Router } from "@angular/router";
import { MatInput } from "@angular/material";

import { VernostServiceService } from "../../../../services/vernost-service.service";
import { saveAs } from "file-saver";
import { DatePipe } from "@angular/common";
import { CommonService } from "../../../../services/common.service";
@Component({
  selector: 'app-email-ftr',
  templateUrl: './email-ftr.component.html',
  styleUrls: ['./email-ftr.component.css']
})
export class EmailFtrComponent implements OnInit {
  @ViewChild("input", { read: MatInput }) input: MatInput;
  @ViewChild("input2", { read: MatInput }) input2: MatInput;
  @ViewChild("input3", { read: MatInput }) input3: MatInput;
  @ViewChild("input4", { read: MatInput }) input4: MatInput;
  @ViewChild("input9", { read: MatInput }) input9: MatInput;
  Gdate;
  from;
  to;
  sdate;
  final;
  screentitle: string = "EMAIL BOOKING FTR";
  downd = true;
  mydate = new Date();
  showsingle = true;
  showMultiple = true;
  showsingle1 = true;
  showMultiple1 = true;
  search_result_list1: any = [];
  searchlist: boolean = true;
  journeydate = false;
  invaliddate = false;
  ftr_email_details;
  isFname = false;
  isLname = false;
  tomorrow1;
  isOrd = false;
  isPnr = false;
  disablebtn = true;
  bookingdate = false;
  dateValid = false;
  tomorrow;
  arr: any = [];
  p: number = 1;
  search_result_list: any = [];
  order_Id_list: any = [];
  search_detail_list: any = [];
  existingbookingEmailFTR: boolean = true;
  bookinglist: boolean = false;
  booking_details: any = "";
  booking_details_info: any = [];
  segment_details: any = "";
  pax_detail: any = "";
  loader: any = false;
  uid;
  cancelbtn;
  BOOKING_STATUS;
  ftr_cancelHistory: any = [];
  ftr_isCancelOpen: boolean = false;
  ftr_isJpNumber: boolean = false;
  ftr_noresult: any = "";
  email_status: any = [
    { key: 1, value: "Success" },
    { key: 0, value: "Failed" }
  ];
  ftr_newDate: any = new Date();
  ftr_myDate: any = new Date();
  ftr_totalItems: number = 1;
  ftr_typeOfRedemption: any = "A";
  ftr_typeOfRedem: any = "A";
  initialPageCount: number = 1;
  constructor(
    private vernostService: VernostServiceService,
    private commonService: CommonService,
    private router: Router,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.ftr_isJpNumber = false;
    this.cancelbtn = true;
    this.ftr_isCancelOpen = false;
    this.uid = localStorage.getItem("uid");
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
    this.ftr_email_details = {
      jp_number: "",
      order_id: "",
      first_name: "",
      last_name: "",
      airlinepnr: "",
      status: "all",
      bookingdate_from: "",
      bookingdate_to: "",
      Ticket_No: ""
    };
  }

  searchForm() {
    this.existingbookingEmailFTR = true;
    this.bookinglist = false;
    this.initialPageCount = 1;
    // this.searchData();
  }
  selectTypeOfRedemption(type) {
    this.ftr_typeOfRedemption = type;
  }
  ngAfterContentInit() {
    this.ftr_email_details.bookingdate_to = new Date();
    this.ftr_email_details.bookingdate_from = new Date();
    this.final = this.ftr_email_details.bookingdate_to.setDate(
      this.ftr_email_details.bookingdate_to.getDate()
    );
    this.final = new Date(this.final);
    this.IsEmptyVal = true;
    // this.searchData();
  }
  pageCount(count) {
    this.p = count;
    this.searchData(count);
  }


  searchData(count) {
    this.ftr_noresult = "";
    if (
      this.ftr_isJpNumber == false &&
      this.isPnr == false &&
      this.isOrd == false &&
      this.isFname == false &&
      this.isLname == false
    ) {
      this.loader = true;
      this.searchlist = false;
      this.cancelbtn = true;
      this.search_result_list = [];
      this.search_result_list1 = [];
      this.order_Id_list = [];
      this.search_detail_list = [];
      var Todate = this.ftr_email_details.bookingdate_to;
      this.toDate(Todate);
      var boofrom = this.ftr_email_details.bookingdate_from;
      var bookto = this.ftr_email_details.bookingdate_to;
      var AirLine_Pnr = this.ftr_email_details.airlinepnr;
      var jp_number = "";
      if (this.ftr_typeOfRedemption == "A") {
        jp_number = this.ftr_email_details.jp_number;
      }
      if (this.ftr_typeOfRedemption == "R") {
        jp_number = "00" + this.ftr_email_details.jp_number;
      }


      var BOOKING_REF_NO = (this.ftr_email_details.order_id.toString().length <= 15 ? this.ftr_email_details.order_id.slice(4, this.ftr_email_details.order_id.length) : this.ftr_email_details.order_id);
      var data = this.commonData(boofrom, bookto, jp_number, BOOKING_REF_NO, AirLine_Pnr);
      data['pagination'] = count;
      data['initialPageCount'] = this.initialPageCount;
      this.p = count;

      // console.log("email ftr : ", data);

    

      this.vernostService.getExistingBooking(data).subscribe(async response => {
        var Data = response;
        this.ftr_typeOfRedem = this.ftr_typeOfRedemption;

        count = Data[0].count;
        this.initialPageCount = Data[0].count
        this.ftr_totalItems = count;
        this.search_result_list = Data[0].result;
        for (var i = 0; i < this.search_result_list.length; i++) {
          this.search_result_list[i].Booking_Ref = (this.search_result_list[i].Booking_Ref.toString().length < 12 ? "JPUB" + this.search_result_list[i].Booking_Ref : this.search_result_list[i].Booking_Ref);
        }

        var Search_Details = [];
        for (var j = 0; j < this.search_result_list.length; j++) {
          if (
            this.order_Id_list.indexOf(
              this.search_result_list[j].Booking_Ref
            ) == -1
          ) {
            this.order_Id_list.push(this.search_result_list[j].Booking_Ref);
            Search_Details.push(this.search_result_list[j]);
          }
        }
        this.search_detail_list = Search_Details;
        if (
          this.search_detail_list.length == 0 ||
          this.search_detail_list == undefined ||
          this.search_detail_list == ""
        ) {
          this.ftr_noresult = "Result Not Found";
          this.loader = false;
        } else {
          this.loader = false;
        }
      });
    }
  }
  commonData(boofrom, bookto, jp_number, BOOKING_REF_NO, AirLine_Pnr) {
    var data = {
      booking_fromdate: boofrom,
      booking_todate: bookto,
      jp_number: jp_number,
      order_id: BOOKING_REF_NO,
      first_name: this.ftr_email_details.first_name,
      last_name: this.ftr_email_details.last_name,
      airlinepnr: AirLine_Pnr.toUpperCase(),
      isMailSent: this.ftr_email_details.status,
      Ticket_No: this.ftr_email_details.Ticket_No,
      typeOfRedemption: this.ftr_typeOfRedemption,
      status : "Email"
    }

    return data;
  }

  toDate(Todate) {
    // if (Todate != "") {
    //   Todate.setDate(Todate.getDate());
    // }
    
    this.ftr_email_details.bookingdate_from = this.datePipe.transform(
      this.ftr_email_details.bookingdate_from,
      "yyyy-MM-dd"
    );
    // Todate = this.datePipe.transform(Todate, "yyyy-MM-dd");

    this.ftr_email_details.bookingdate_to = this.datePipe.transform(
      this.ftr_email_details.bookingdate_to,
      "yyyy-MM-dd"
    );
    
  }

  keypresshandler(event) {
    var charCode = event.keyCode;
    //Non-numeric character range
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  }

  jpNumberValidation() {
    this.disablebtn = false;
    var JPNo = this.ftr_email_details.jp_number;
    this.ftr_isJpNumber = this.commonService.validation('jpnumbervalidation', /^[A-Za-z0-9_]+$/, JPNo);
  }

  ticketValidation() {
    this.disablebtn = false;
    var JPNo = this.ftr_email_details.Ticket_No;
    this.ftr_isJpNumber = this.commonService.validation('ticketvalidation', /^[A-Za-z0-9_]+$/, JPNo);
  }

  jpNumberValidation1() {
    this.disablebtn = false;
    var JPNo = this.ftr_email_details.jp_number;
    this.ftr_isJpNumber = this.commonService.validation('jpnumbervalidation1', '', JPNo);
  }

  ticketValidation1() {
    this.disablebtn = false;
    var JPNo = this.ftr_email_details.Ticket_No;
    this.ftr_isJpNumber = this.commonService.validation('ticketvalidation1', '', JPNo);
  }

  fnameValidation() {
    this.disablebtn = false;
    var JPNo = this.ftr_email_details.first_name;
    this.isFname = this.commonService.validation('fname', /^[A-Za-z]+$/, JPNo);
  }
  lnameValidation() {
    this.disablebtn = false;
    var JPNo = this.ftr_email_details.last_name;
    this.isLname = this.commonService.validation('fname', /^[A-Za-z]+$/, JPNo);
  }
  orderValidation() {
    this.disablebtn = false;
    var JPNo = this.ftr_email_details.order_id;
    this.isOrd = this.commonService.validation('orderValidation', /^[A-Za-z0-9_]+$/, JPNo);
  }

  orderValidation1() {
    this.disablebtn = false;
    var JPNo = this.ftr_email_details.order_id;
    this.isOrd = this.commonService.validation('orderValidation1', '', JPNo);
  }

  pnrValidation1() {
    this.disablebtn = false;
    var JPNo = this.ftr_email_details.airlinepnr;
    this.isPnr = this.commonService.validation('pnrValidation1', '', JPNo);
  }

  pnrValidation() {
    this.disablebtn = false;
    var JPNo = this.ftr_email_details.airlinepnr;
    this.isPnr = this.commonService.validation('pnrValidation', /^[A-Za-z0-9_]+$/, JPNo);
  }


  toggleDisable2() {
    // this.journeydate = true;
    this.ftr_email_details.bookingdate_to = "";
  }

  IsEmptyVal: boolean = false;
  isEmpty() {
    if (
      this.ftr_email_details.jp_number == "" &&
      this.ftr_email_details.airlinepnr == "" &&
      this.ftr_email_details.order_id == "" &&
      this.ftr_email_details.Ticket_No == "" &&
      this.ftr_email_details.first_name == "" &&
      this.ftr_email_details.last_name == "" &&
      this.ftr_email_details.status == "all" &&
      (this.ftr_email_details.bookingdate_from == "" ||
        this.ftr_email_details.bookingdate_to == "")
    ) {
      this.IsEmptyVal = false;
    } else {
      this.IsEmptyVal = true;
    }

  }
  checkempty() {
    // if()
    if (
      this.ftr_email_details.bookingdate_from == "" ||
      this.ftr_email_details.bookingdate_to == ""
    ) {
      this.dateValid = true;
    } else {
      this.dateValid = false;
    }

    if (
      this.ftr_email_details.jp_number.length == 0 &&
      this.ftr_email_details.Ticket_No.length == 0 &&
      this.ftr_email_details.last_name.length == 0 &&
      this.ftr_email_details.first_name.length == 0 &&
      this.ftr_email_details.airlinepnr.length == 0 &&
      this.ftr_email_details.order_id.length == 0 &&
      this.ftr_email_details.status == "all"
    ) {
      this.disablebtn = true;
    }

    if (
      this.ftr_email_details.jp_number.length == 0 &&
      this.ftr_email_details.last_name.length == 0 &&
      this.ftr_email_details.first_name.length == 0 &&
      this.ftr_email_details.airlinepnr.length == 0 &&
      this.ftr_email_details.order_id.length == 0 &&
      this.ftr_email_details.Ticket_No.length == 0 &&
      this.ftr_email_details.status != "all"
    ) {
      this.ftr_isJpNumber = false;
      this.disablebtn = false;
      this.isFname = false;
      this.isLname = false;
      this.isPnr = false;
      this.isOrd = false;
      this.invaliddate = false;
      this.dateValid = false;
    }

    if (
      (this.ftr_email_details.jp_number.length != 0 ||
        this.ftr_email_details.last_name.length != 0 ||
        this.ftr_email_details.Ticket_No.length != 0 ||
        this.ftr_email_details.first_name.length != 0 ||
        this.ftr_email_details.airlinepnr.length != 0 ||
        this.ftr_email_details.order_id.length != 0 ||
        this.ftr_email_details.status != "all") &&
      (this.ftr_email_details.bookingdate_from != "" &&
        this.ftr_email_details.bookingdate_to != "")
    ) {
      this.disablebtn = false;
    }

    if (
      (this.ftr_email_details.jp_number.length != 0 ||
        this.ftr_email_details.last_name.length != 0 ||
        this.ftr_email_details.first_name.length != 0 ||
        this.ftr_email_details.Ticket_No.length != 0 ||
        this.ftr_email_details.airlinepnr.length != 0 ||
        this.ftr_email_details.order_id.length != 0 ||
        this.ftr_email_details.status != "all") &&
      (this.ftr_email_details.bookingdate_from == "" &&
        this.ftr_email_details.bookingdate_to == "")
    ) {
      this.disablebtn = false;
    }

    if (
      this.ftr_email_details.bookingdate_from == "" &&
      this.ftr_email_details.bookingdate_to != ""
    ) {
      this.disablebtn = true;
    }

    if (
      this.ftr_email_details.bookingdate_from != "" &&
      this.ftr_email_details.bookingdate_to == ""
    ) {
      this.disablebtn = true;
    }
  }


  reset(frombtn) {
    if (frombtn == 'reset') {
      this.input9.value = "";
      this.tomorrow = "";
      this.isEmpty();
    }
    if (frombtn == 'reset2') {
      this.input2.value = "";
    }
    if (frombtn == 'reset3') {
      this.input3.value = "";
      this.ftr_email_details.bookingdate_from = "";
      this.tomorrow1 = "";
      this.final = "";
      this.isEmpty();
    }
    if (frombtn == 'reset4') {
      this.input4.value = "";
      this.ftr_email_details.bookingdate_to = "";
      this.isEmpty();
    }
  }

  getReprt() {
    //req.body.fromdate != "" && req.body.todate
    this.ftr_noresult = "";
    if (
      this.ftr_isJpNumber == false &&
      this.isPnr == false &&
      this.isOrd == false &&
      this.isFname == false &&
      this.isLname == false
    ) {
      this.loader = true;
      var Todate = this.ftr_email_details.bookingdate_to;
      this.toDate(Todate);
      var boofrom = this.ftr_email_details.bookingdate_from;
      var bookto = this.ftr_email_details.bookingdate_to;
      var AirLine_Pnr = this.ftr_email_details.airlinepnr;
      var jp_number = "";
      if (this.ftr_typeOfRedemption == "A") {
        jp_number = this.ftr_email_details.jp_number;
      }
      if (this.ftr_typeOfRedemption == "R") {
        jp_number = "00" + this.ftr_email_details.jp_number;
      }

      var BOOKING_REF_NO = (this.ftr_email_details.order_id.toString().length <= 15 ? this.ftr_email_details.order_id.slice(4, this.ftr_email_details.order_id.length) : this.ftr_email_details.order_id);

      var data = this.commonData(boofrom, bookto, jp_number, BOOKING_REF_NO, AirLine_Pnr);

      var url = "";
      // if (this.ftr_typeOfRedemption == "R") {
      //   url = "RedeemFTRReport";
      // } else {
      //   url = "AccrualFTRReport";
      // }

      this.vernostService.downloadEmailBooking(data).subscribe(
        result => {

          console.log("result : ")
          this.ftr_noresult = "";
          if (result.size != 0) {
            saveAs(result, "EmailFTR.csv");
          } else {
            this.ftr_noresult = "Result Not Found";
          }
          this.loader = false;
        },
        err => { }
      );
    }
  }
 

  incresedate() {
    var tomorrow = (document.getElementById("did") as HTMLInputElement).value;
    var tam = new Date(tomorrow);
    this.final = tam.setDate(tam.getDate());
    this.final = new Date(this.final);
  }

  checkStatus1() {
    this.mydate = this.ftr_email_details.bookingdate_from;
    this.checkempty();
    this.showsingle1 = true;
    this.showMultiple1 = true;

    if (
      this.ftr_email_details.bookingdate_from != "" &&
      this.ftr_email_details.bookingdate_to != ""
    ) {
      this.downd = false;
    } else {
      this.downd = true;
    }
  }
  
}
